export default "__VITE_ASSET__BmKIGD6Y__"